import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useErrorHandlerContext, useUserLanguage } from '@/customHooks'
import { useOwnerContractDetailsContext } from '@/customHooks/useOwnerContractDetailsContext'
import { useGetOwnerContractQuery } from '@/graphql/generated'
import textsData from '@/textData/OwnerContractDetailsTexts.json'
import { NavTabsProps, NavTabsWithActions } from '../molecules'
import { pathURL } from '@/components/constants/urls'
import { LoadingSpinner } from '../atoms'
import { OwnerContractDetailTemplate } from '../templates'

export const OwnerContractDetailPage = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.tabs : textsData.en.tabs

  const [selectedTab, setSelectedTab] = useState('1')
  const [initialMount, setInitialMount] = useState(true);

  const location = useLocation()
  const navigate = useNavigate()

  const { contract, setContract } = useOwnerContractDetailsContext()
  
  const { data, loading, error, refetch} = useGetOwnerContractQuery({
    variables: {
      id: location.state.id,
    }
  })

  const { open: errorHandler } = useErrorHandlerContext()

  useEffect(() => {
    if (data?.ownerContract) {
      setContract(data.ownerContract);
    }
  }, [data, setContract]);
  
  useEffect(() => {
    if (error) {
      errorHandler(error)
    }
  }, [error])

  useEffect(() => {
    if (!location.state?.id) {
      navigate(`/${pathURL.USER}`, { replace: true })
    }
  }, [location.state?.id, navigate])

  useEffect(() => {
    if (initialMount === true) {
      setInitialMount(false);
      return;
    }

    if (contract === undefined && !loading) {
      refetch();
    }
  }, [contract, loading, refetch]);

  const tabs: NavTabsProps[] = [
    { id: '1', label: texts.tab1 },
    { id: '2', label: texts.tab2 },
    { id: '3', label: texts.tab3 },
  ]

  if (loading) {
    return (
      <div className="flex justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <>
      <div className="flex justify-center">
        <NavTabsWithActions
          tabs={tabs}
          selectedTabId={selectedTab}
          onClick={setSelectedTab}
        />
      </div>
      <OwnerContractDetailTemplate selectedSection={selectedTab} />
    </>
  )
}